import React from "react";
import { useParams } from "react-router-dom";
import { gql, useQuery } from "@apollo/client";
import logo from "../campofruver-blanco-y-negro-1.png";

const GET_PEDIDO_BY_NUMERO = gql`
  query getPedidoByNumero($numeroPedido: Int!) {
    getPedidoByNumero(numeroPedido: $numeroPedido) {
      _id
      fecha
      numeroPedido
      nombreCliente
      whatsappCliente
      productos
    }
  }
`;

function FacturaCliente() {
  const { numeroPedido } = useParams();

  // Limpieza del número en la URL
  const limpio = numeroPedido
    .replace(/^qeodencompra28756wurotyur34212qwew-/, "")
    .replace(/-q123lkcxdepedido#23143rty$/, "");

  const numeroSinRelleno = parseInt(limpio, 10);

  const { data, loading, error } = useQuery(GET_PEDIDO_BY_NUMERO, {
    variables: { numeroPedido: numeroSinRelleno },
  });

  if (loading) return <p>Cargando...</p>;
  if (error) return <p>Error: {error.message}</p>;

  const pedido = data?.getPedidoByNumero;
  if (!pedido) return <p>Pedido no encontrado</p>;

  // Parsear los productos
  let productos = [];
  try {
    productos = JSON.parse(pedido.productos);
  } catch {}

  // Cálculo real del subtotal
  const calcularSubtotal = (prod) =>
    prod.codigo === "1"
      ? prod.precio * prod.cantidad 
      : prod.precio * prod.cantidad;

  const total = productos.reduce((sum, prod) => sum + calcularSubtotal(prod), 0);

  return (
    <div
      style={{
        maxWidth: "600px",
        margin: "30px auto",
        padding: "20px",
        border: "1px solid #ccc",
        borderRadius: "10px",
        backgroundColor: "#fff",
        fontFamily: "Arial, sans-serif",
        boxShadow: "0 2px 8px rgba(0,0,0,0.1)",
      }}
    >
      {/* LOGO */}
      <div style={{ textAlign: "center", marginBottom: "10px" }}>
        <img
          src={logo}
          alt="Campo Fruver Logo"
          style={{ width: "90px", height: "auto", marginBottom: "8px" }}
        />
       
        <p style={{ margin: 0 }}>322 614 0639</p>
        <p style={{ margin: 0 }}>Carre 11 N° 7-16 La Unión Ant.</p>
        <hr />
        <h4 style={{ margin: "10px 0" }}>
          Factura de venta Nº 00{String(numeroSinRelleno).padStart(4, "0")}-1
        </h4>
      </div>

      {/* DATOS DEL CLIENTE */}
      <div style={{ marginBottom: "15px", fontSize: "0.95em" }}>
      
        <p>
          <strong>Fecha:</strong>{" "}
  {new Date(new Date(pedido.fecha).getTime() - 5 * 60 * 60 * 1000)
  .toLocaleDateString("es-CO", {
    year: "numeric",
    month: "long",
    day: "numeric",
  })}

        </p>
      </div>

      {/* TABLA DE PRODUCTOS */}
      <table
        style={{
          width: "100%",
          borderCollapse: "collapse",
          marginBottom: "10px",
          fontSize: "0.9em",
        }}
      >
        <thead>
          <tr style={{ backgroundColor: "#f0f0f0", borderBottom: "2px solid #ccc" }}>
            <th style={{ textAlign: "left", padding: "8px" }}>Producto</th>
            <th style={{ textAlign: "center", padding: "8px" }}>Cant.</th>
            <th style={{ textAlign: "right", padding: "8px" }}>P. Unitario</th>
            <th style={{ textAlign: "right", padding: "8px" }}>Subtotal</th>
          </tr>
        </thead>
        <tbody>
          {productos.map((p, i) => {
            const subtotal = calcularSubtotal(p);
            // Solo mostrar visualmente el precio ajustado si el código es "1"
            const precioVisual =
              p.codigo === "1" ? p.precio * 1000  : p.precio;

            return (
              <tr key={i}>
                <td style={{ padding: "6px", borderBottom: "1px solid #eee" }}>
                  {p.nombre}
                </td>
                <td
                  style={{
                    textAlign: "center",
                    padding: "6px",
                    borderBottom: "1px solid #eee",
                  }}
                >
                  {p.cantidad}
                </td>
                <td
                  style={{
                    textAlign: "right",
                    padding: "6px",
                    borderBottom: "1px solid #eee",
                  }}
                >
                  ${precioVisual.toLocaleString()}
                </td>
                <td
                  style={{
                    textAlign: "right",
                    padding: "6px",
                    borderBottom: "1px solid #eee",
                  }}
                >
                  ${subtotal.toLocaleString()}
                </td>
              </tr>
            );
          })}
        </tbody>
      </table>

      {/* TOTAL */}
      <div
        style={{
          textAlign: "right",
          fontWeight: "bold",
          fontSize: "1.1em",
          borderTop: "2px solid #ccc",
          paddingTop: "8px",
        }}
      >
        Total: ${total.toLocaleString()}
      </div>

      {/* PIE */}
      <div
        style={{
          textAlign: "center",
          marginTop: "15px",
          fontSize: "0.9em",
          color: "#1f1e1eff",
        }}
      >
        <h5>Gracias por elegirnos</h5>
        <p>Campo Fruver - {new Date().getFullYear()}</p>
      </div>
    </div>
  );
}

export default FacturaCliente;